import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { DEMO_CUENTAS } from "@/data/demo";
const TOKEN_KEY = "ceAuthToken";
const NAME_KEY = "ceDisplayName";
const EMAIL_KEY = "ceEmail";
const PERFIL_KEY = "cePerfil";
const INTEGRADOR_KEY = "ceIntegradorId";
export const useAuthStore = defineStore("auth", () => {
    const sessionToken = ref(localStorage.getItem(TOKEN_KEY) || "");
    const displayName = ref(localStorage.getItem(NAME_KEY) || "");
    const email = ref(localStorage.getItem(EMAIL_KEY) || "");
    const perfil = ref(localStorage.getItem(PERFIL_KEY) || "");
    const integradorId = ref(localStorage.getItem(INTEGRADOR_KEY) || "");
    const sessionIsValidNow = () => sessionToken.value === "mock-session";
    const isAuthenticated = computed(() => sessionIsValidNow());
    const isAdmin = computed(() => perfil.value === "ADMINISTRADOR");
    const isCertificador = computed(() => perfil.value === "CERTIFICADOR");
    const isIntegrador = computed(() => perfil.value === "INTEGRADOR");
    const canOperate = computed(() => perfil.value === "ADMINISTRADOR" || perfil.value === "CERTIFICADOR");
    const setSession = async (payload) => {
        localStorage.setItem(TOKEN_KEY, "mock-session");
        localStorage.setItem(NAME_KEY, payload.displayName);
        localStorage.setItem(EMAIL_KEY, payload.email);
        localStorage.setItem(PERFIL_KEY, payload.perfil);
        if (payload.integradorId) {
            localStorage.setItem(INTEGRADOR_KEY, payload.integradorId);
        }
        else {
            localStorage.removeItem(INTEGRADOR_KEY);
        }
        sessionToken.value = "mock-session";
        displayName.value = payload.displayName;
        email.value = payload.email;
        perfil.value = payload.perfil;
        integradorId.value = payload.integradorId ?? "";
    };
    const loginDemo = async (cuentaEmail, password) => {
        const cuenta = DEMO_CUENTAS.find((item) => item.email.toLowerCase() === cuentaEmail.trim().toLowerCase() &&
            item.password === password);
        if (!cuenta) {
            throw new Error("Credenciales inválidas. Usa una cuenta demo.");
        }
        await setSession({
            displayName: cuenta.nombre,
            email: cuenta.email,
            perfil: cuenta.perfil,
            integradorId: cuenta.integradorId,
        });
        return cuenta;
    };
    const loginComoPerfil = async (perfilDemo) => {
        const cuenta = DEMO_CUENTAS.find((item) => item.perfil === perfilDemo);
        if (!cuenta) {
            throw new Error("Perfil demo no encontrado.");
        }
        await setSession({
            displayName: cuenta.nombre,
            email: cuenta.email,
            perfil: cuenta.perfil,
            integradorId: cuenta.integradorId,
        });
    };
    const clearSession = async () => {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(NAME_KEY);
        localStorage.removeItem(EMAIL_KEY);
        localStorage.removeItem(PERFIL_KEY);
        localStorage.removeItem(INTEGRADOR_KEY);
        localStorage.removeItem("lastRoute");
        sessionToken.value = "";
        displayName.value = "";
        email.value = "";
        perfil.value = "";
        integradorId.value = "";
    };
    return {
        displayName,
        email,
        perfil,
        integradorId,
        isAuthenticated,
        isAdmin,
        isCertificador,
        isIntegrador,
        canOperate,
        sessionIsValidNow,
        setSession,
        loginDemo,
        loginComoPerfil,
        clearSession,
    };
});
